module.exports = __webpack_public_path__ + "img/34.50a29193.jpg";